import i18n from 'i18next'
import {initReactI18next} from 'react-i18next'
import en from 'modules/i18n/en'
import uk from 'modules/i18n/uk'

const resources = {
  en,
  uk,
}

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: 'uk',
  debug: true,
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
